var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientsColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.94531C6.38 2.94531 4.25 5.07531 4.25 7.69531C4.25 10.2653 6.26 12.3453 8.88 12.4353C8.96 12.4253 9.04 12.4253 9.1 12.4353C9.12 12.4353 9.13 12.4353 9.15 12.4353C9.16 12.4353 9.16 12.4353 9.17 12.4353C11.73 12.3453 13.74 10.2653 13.75 7.69531C13.75 5.07531 11.62 2.94531 9 2.94531Z",
    fill: "#4B4AD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.08 15.0962C11.29 13.2362 6.73996 13.2362 3.92996 15.0962C2.65996 15.9462 1.95996 17.0962 1.95996 18.3262C1.95996 19.5562 2.65996 20.6962 3.91996 21.5362C5.31996 22.4762 7.15996 22.9462 8.99996 22.9462C10.84 22.9462 12.68 22.4762 14.08 21.5362C15.34 20.6862 16.04 19.5462 16.04 18.3062C16.03 17.0762 15.34 15.9362 14.08 15.0962Z",
    fill: "#4B4AD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9904 8.28541C20.1504 10.2254 18.7704 11.9254 16.8604 12.1554C16.8504 12.1554 16.8504 12.1554 16.8404 12.1554H16.8104C16.7504 12.1554 16.6904 12.1554 16.6404 12.1754C15.6704 12.2254 14.7804 11.9154 14.1104 11.3454C15.1404 10.4254 15.7304 9.04541 15.6104 7.54541C15.5404 6.73541 15.2604 5.99541 14.8404 5.36541C15.2204 5.17541 15.6604 5.05541 16.1104 5.01541C18.0704 4.84541 19.8204 6.30541 19.9904 8.28541Z",
    fill: "#4B4AD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9902 17.5357C21.9102 18.5057 21.2902 19.3457 20.2502 19.9157C19.2502 20.4657 17.9902 20.7257 16.7402 20.6957C17.4602 20.0457 17.8802 19.2357 17.9602 18.3757C18.0602 17.1357 17.4702 15.9457 16.2902 14.9957C15.6202 14.4657 14.8402 14.0457 13.9902 13.7357C16.2002 13.0957 18.9802 13.5257 20.6902 14.9057C21.6102 15.6457 22.0802 16.5757 21.9902 17.5357Z",
    fill: "#4B4AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsColored);
export default __webpack_public_path__ + "static/media/patients-colored.8cd48b4820ddce07c012266286ea87b4.svg";
export { ForwardRef as ReactComponent };